import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TUI_DARK_MODE } from '@taiga-ui/core/tokens';
import { TuiLanguageSwitcherService } from '@taiga-ui/i18n';
import { environment } from 'src/environments/environment';

import { BrandingService } from '@branding/branding.service';
import { DevBrandingService } from '@common/utils/dev-tools/dev-branding/dev-branding.service';
import { initializeLanguage, mapLanguageToTui } from '@common/utils/lang';
import { AppService } from '@services/app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false,
})
export class AppComponent implements OnInit {
  protected readonly night = inject(TUI_DARK_MODE);
  private readonly switcher = inject<TuiLanguageSwitcherService>(TuiLanguageSwitcherService);
  private readonly translate = inject(TranslateService);
  private readonly appService = inject(AppService);
  private readonly brandingService = inject(BrandingService);
  private readonly devBrandingService = inject(DevBrandingService);

  title = 'phoenix-frontend';

  isLoading = this.appService.isLoading;

  // Сюда подсовываем строку с названием атрибута для изменения основных оттенков
  // Название этого атрибута должно использоваться лишь в одном месте, глобальном файле со стилями styles.less
  // Подсовываем null в случае, если не хотим применять ничего кастомного
  // В случае опечатки или незарегистрированного атрибута, будут использованы дефолтные цвета
  get dataTheme(): string {
    return this.brandingService.brand.dataThemeAttr;
  }

  get mode(): 'onDark' | 'onLight' | null {
    return this.night() ? 'onDark' : null;
  }

  ngOnInit(): void {
    this.brandingService.updateBranding();
    this.devBrandingService.restore();

    const selectedLanguage = initializeLanguage(
      this.translate,
      environment.defaultLocale,
      environment.locales,
    );
    this.switcher.setLanguage(mapLanguageToTui(selectedLanguage));
  }
}
